export default __webpack_public_path__ + "static/media/double-caret.2b993151.svg";